export const CLIENT_ID = process.env.REACT_APP_SPOTIFY_CLIENT_ID;
export const REDIRECT_URI = process.env.REACT_APP_SPOTIFY_REDIRECT_URI;
export const SPOTIFY_SCOPE = process.env.REACT_APP_SPOTIFY_SCOPE;
